import TimeUnitManagementComponent from 'components/desktop/StandingData/TimeUnit/Management/TimeUnitManagementComponent';

const TimeUnitArchiveContainer = () => {
	const renderContent = () => {
		return (
			<main className="container">
				<TimeUnitManagementComponent archive={true} />
			</main>
		);
	};

	return <>{renderContent()}</>;
};

export default TimeUnitArchiveContainer;
